import React, { useEffect, useState } from "react";
import axios from "axios";

// Organizar servicio → interruptor "Solo esta semana" (desactivado por defecto).
// Activado: la organización de esta semana no se copia a las semanas siguientes
// (se copian de la última semana sin marcar). Backend: /servicio/plan-opciones.

const fmt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")} a las ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

const lunesDeHoy = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
};

export default function SoloEstaSemana({ pisoId, semana, onCambio }) {
  const [datos, setDatos] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!pisoId || !semana) return;
    setDatos(null); setError("");
    axios.get(`/api/servicio/plan-opciones/${pisoId}/${semana}`)
      .then((r) => setDatos(r.data))
      .catch(() => setDatos({ solo_esta_semana: false }));
  }, [pisoId, semana]);

  if (!datos) return null;
  const activo = !!datos.solo_esta_semana;
  const [y, m, d] = semana.split("-").map(Number);
  const pasada = new Date(y, m - 1, d) < lunesDeHoy();

  const cambiar = async () => {
    if (pasada || guardando) return;
    setGuardando(true); setError("");
    try {
      await axios.post(`/api/servicio/plan-opciones/${pisoId}/${semana}`, { solo_esta_semana: !activo });
      const r = await axios.get(`/api/servicio/plan-opciones/${pisoId}/${semana}`);
      setDatos(r.data);
      if (onCambio) onCambio();
    } catch (e) {
      setError((e.response && e.response.data && e.response.data.error) || "No se ha podido guardar");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{
      margin: "10px auto 14px", maxWidth: 760, borderRadius: 14, padding: "12px 14px",
      border: activo ? "2px solid #7c3aed" : "1px solid #e2e8f0",
      background: activo ? "linear-gradient(135deg,#f5f3ff,#ede9fe)" : "#f8fafc",
      boxShadow: activo ? "0 4px 14px rgba(124,58,237,0.18)" : "none",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 900, fontSize: 16, color: activo ? "#5b21b6" : "#1e293b" }}>
            📌 Solo esta semana
            <span style={{
              marginLeft: 8, fontSize: 12, fontWeight: 900, borderRadius: 999, padding: "2px 9px", verticalAlign: "middle",
              background: activo ? "#7c3aed" : "#e2e8f0", color: activo ? "#fff" : "#475569",
            }}>{activo ? "ACTIVADO" : "DESACTIVADO"}</span>
          </div>
          <div style={{ fontSize: 13.5, color: "#475569", marginTop: 4, lineHeight: 1.45 }}>
            {activo
              ? <>Los cambios de esta semana <b>no se copiarán</b> a las semanas siguientes. Las siguientes seguirán la organización de siempre.</>
              : <>Ahora, lo que organices esta semana <b>se copia también a las semanas siguientes</b>. Actívalo si esta semana es especial (festivo, ausencias…) y solo quieres cambiarla a ella.</>}
          </div>
          {activo && datos.marcado_por && (
            <div style={{ fontSize: 12, color: "#7c3aed", marginTop: 4 }}>Activado por {datos.marcado_por} el {fmt(datos.marcado_at)}</div>
          )}
          {pasada && <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>Semana pasada: ya no se puede cambiar.</div>}
          {error && <div style={{ fontSize: 13, color: "#b91c1c", marginTop: 4 }}>{error}</div>}
        </div>
        {/* interruptor */}
        <button
          role="switch" aria-checked={activo} aria-label="Solo esta semana"
          onClick={cambiar} disabled={pasada || guardando}
          style={{
            flexShrink: 0, width: 64, height: 36, borderRadius: 999, border: "none", padding: 3,
            cursor: pasada ? "not-allowed" : "pointer", opacity: pasada ? 0.5 : (guardando ? 0.7 : 1),
            background: activo ? "#7c3aed" : "#cbd5e1", transition: "background .2s", position: "relative",
          }}
        >
          <span style={{
            display: "block", width: 30, height: 30, borderRadius: "50%", background: "#fff",
            boxShadow: "0 1px 4px rgba(0,0,0,0.25)", transition: "transform .2s",
            transform: activo ? "translateX(28px)" : "translateX(0)",
          }} />
        </button>
      </div>
    </div>
  );
}
